'use client'

import '@mdxeditor/editor/style.css';

import {
	headingsPlugin,
	listsPlugin,
	quotePlugin,
	markdownShortcutPlugin,
	MDXEditor,
	linkPlugin,
	linkDialogPlugin,
	imagePlugin,
	MDXEditorMethods
} from '@mdxeditor/editor';
import { FC, useEffect, useRef } from 'react';

interface EditorProps {
  markdown: string
}

export const Editor: FC<EditorProps> = ({ markdown }) => {
	const editorRef = useRef<MDXEditorMethods>(null);

	/**
	 * It a workaround for the bug, when images doesn't load on a first render, and require the editor element to be clicked
	 */
	useEffect(() => {
		setTimeout(() => {
			editorRef.current?.focus();
		}, 1000);
	}, [editorRef.current]);

	return (<MDXEditor
		ref={editorRef}
		readOnly={true}
		markdown={markdown}
		plugins={[
			headingsPlugin(),
			listsPlugin(),
			linkPlugin(),
			linkDialogPlugin(),
			quotePlugin(),
			markdownShortcutPlugin(),
			imagePlugin(),
		]}
	/>);
};
